<div class="draggable-item">
    <div [dragData]="data" [dragEnabled]="true" [dropZones]="dropZones"
         class="draggable-item-content" dnd-draggable>
        <div class="draggable-item-content-grip">
            <fui-icon [height]="18" [icon]="'drag-2x4'" [width]="15"></fui-icon>
        </div>
        <div *ngIf="icon" class="draggable-item-content-icon">
            <fui-icon [height]="18" [icon]="icon" [width]="15"></fui-icon>
        </div>
        <div class="draggable-item-content-text" [ngClass]="{'draggable-item-content-text-mandatory': data.mandatory}">
            {{label | translate}}
        </div>
    </div>
</div>
